export default __webpack_public_path__ + "static/media/steel.f75dfe50.png";